import axios from 'axios'
import Cookies from 'js-cookie'

const API_URL = process.env.REACT_APP_BACKEND_URL

export const getAllVideo = async ({ currentPage, search }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.get(`${API_URL}/api/features`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        pagination: {
          pageSize: 10,
          page: currentPage,
        },
        filters: {
          title: {
            $containsi: search,
          },
        },
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching video data:', error)
    throw error
  }
}

export const getDetailVideo = async ({ id }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.get(`${API_URL}/api/features/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching video data:', error)
    throw error
  }
}

export const deleteVideo = async ({ id }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.delete(`${API_URL}/api/features/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return response.data
  } catch (error) {
    console.error('Error deleting video data:', error)
    throw error
  }
}

export const createVideo = async ({ form }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.post(`${API_URL}/api/features`, form, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error deleting video data:', error)
    throw error
  }
}

export const updateVideo = async ({ id, form }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.put(`${API_URL}/api/features/${id}`, form, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error deleting video data:', error)
    throw error
  }
}
